import {View, Text, StyleSheet, Linking} from 'react-native';
import React from 'react';
import {_m} from 'INTL';
import SkillzStyle from 'SkillzStyle';
import {PLAYTHROUGH_FAQ_URL} from '../BankWithdrawalConstants';
import ClientPropertyConstants from 'ClientPropertyConstants';
import {trackTelemetryEvent} from 'TrackTelemetryEvent';
import {TelemetryEventName} from 'TelemetryConstants';
const {fontRegular} = SkillzStyle.fullStyles;

type InfoItem = {
  id: string;
  text: string;
  linkText?: string;
  textAfterLink?: string;
};

type WithdrawalInfoListProps = {
  isRTPEnabled?: boolean | undefined;
};

const WithdrawalInfoList = ({isRTPEnabled}: WithdrawalInfoListProps) => {
  const data: InfoItem[] = [
    {id: '1', text: _m('Bonus Cash can’t be withdrawn and will be forfeited.')},
    {id: '2', text: _m('Withdrawals less than $10 will incur a $1.50 fee.')},
    {id: '3', text: _m('Need more info? Check out the'), linkText: _m('FAQ'), textAfterLink: _m('or contact Support.')},
  ];

  const rtpEnabledData: InfoItem[] = [
    {id: '1', text: _m('Bonus Cash can’t be withdrawn and will be forfeited.')},
    {id: '2', text: _m('Withdrawals less than $10 will incur a $1.50 fee.')},
    {id: '3', text: _m('Need more info? Check out the'), linkText: _m('FAQ'), textAfterLink: _m('or contact Support.')},
  ];

  // If RTP is enabled and the withdrawal fee is disabled, remove the withdrawal fee message
  if (isRTPEnabled) {
    const withdrawalFeeEnabled = ClientPropertyConstants.getPlayerWithdrawalAeropayRTPFeeEnabled();
    if (!withdrawalFeeEnabled) {
      rtpEnabledData.splice(1, 1);
    }
  }

  const handleFAQLinkPress = () => {
    trackTelemetryEvent({
      event: TelemetryEventName.WITHDRAW_BANK_PAGE_CTA_CLICK,
      payload: {
        cta: 'See FAQ',
      },
      includeUserWalletDetails: true,
    });
    Linking.openURL(PLAYTHROUGH_FAQ_URL);
  };

  const dataToDisplay = isRTPEnabled ? rtpEnabledData : data;

  return (
    <View style={styles.container}>
      {dataToDisplay.map((item, index) => (
        <View key={index} style={styles.listItem}>
          <Text style={styles.bullet} allowFontScaling={false}>
            {'\u2022'}
          </Text>
          <View style={styles.textContainer}>
            <Text style={styles.text} allowFontScaling={false}>
              {item.text}
            </Text>
            {item.linkText && (
              <Text style={styles.linkText} onPress={handleFAQLinkPress} allowFontScaling={false}>
                {item.linkText}
              </Text>
            )}
            {item.textAfterLink && (
              <Text style={styles.text} allowFontScaling={false}>
                {item.textAfterLink}
              </Text>
            )}
          </View>
        </View>
      ))}
    </View>
  );
};

export default WithdrawalInfoList;

const styles = StyleSheet.create({
  container: {
    margin: 10,
    paddingHorizontal: 5,
  },
  listItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 3,
  },
  bullet: {
    fontSize: 16,
    marginRight: 8,
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 3,
  },
  text: {
    fontSize: 13,
    ...fontRegular,
    color: '#333',
  },
  linkText: {
    fontSize: 13,
    ...fontRegular,
    color: '#367BCE',
  },
});
